export default __webpack_public_path__ + "static/media/me5.98350d72.gif";